export default __webpack_public_path__ + "static/media/ser_prv_1.edf97e0f.png";